import config from '~/config'
import Crypto from '@/util/crypto'

/**
 * @returns {String}
 */
export function getClientType() {
  var u = navigator.userAgent
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  return isiOS ? 'ios' : 'android'
}

/**
 * 图片瘦身处理，检测到图片是七牛云cdn时，自动进行瘦身处理
 * @param {*} url
 */
export function slimImg(url) {
  if (url.includes('img.rr.tv') && !url.includes('?')) {
    return url + '?imageslim'
  }
  return url
}
/**
 * 跳转app
 * @param {*}
 */
export function goApp() {
  let url
  switch (getClientType()) {
    case 'ios':
      url = config.APPLINK.IOS
      break
    case 'android':
      url = config.APPLINK.ANDROID
      break
    default:
      url = config.APPLINK.ANDROID
  }
  window.open(url)
}

export const formatDate = (date, format) => {
  //将日期时间进行格式化
  //name="date" type="Date" 要格式化的日期时间
  //name="format" type="String" 格式类型，形如 yyyy-MM-dd hh:mm:ss
  var o = {
    'M+': date.getMonth() + 1,
    //月份
    'd+': date.getDate(),
    //日
    'h+': date.getHours(),
    //小时
    'm+': date.getMinutes(),
    //分
    's+': date.getSeconds() //秒
  }
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) if (new RegExp('(' + k + ')').test(format)) format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
  return format
}

export const mergeDeep = (target, source) => {
  const isObject = (obj) => obj && typeof obj === 'object'

  if (!isObject(target) || !isObject(source)) {
    return source
  }

  Object.keys(source).forEach((key) => {
    const targetValue = target[key]
    const sourceValue = source[key]

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue)
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = mergeDeep(Object.assign({}, targetValue), sourceValue)
    } else {
      target[key] = sourceValue
    }
  })

  return target
}
export const htmlDecode = function (text) {
  //1.首先动态创建一个容器标签元素，如DIV
  var temp = document.createElement('div')
  //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
  temp.innerHTML = text
  //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
  var output = temp.innerText || temp.textContent
  temp = null
  return output
}

export const cookieToJson = function (cookie) {
  let cookieArr = cookie.split(';')
  let obj = {}
  cookieArr.forEach((i) => {
    let arr = i.split('=')
    obj[arr[0].trim()] = arr[1]
  })
  return obj
}

export function UUID() {
  let s = []
  let hexDigits = '0123456789abcdefghijklmnopqrstuvwxyz'
  for (let i = 0; i < 16; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  // s[14] = '4'
  // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  // s[8] = s[13] = s[18] = s[23] = '-'
  let uuid = s.join('')
  return uuid
}

// export function convertObj(data, isSort = false) {
//   var _result = []

//   for (var key in data) {
//     var value = data[key]
//     if (value.constructor == Array) {
//       value.forEach(function (_value) {
//         //_result.push(_value)
//         _result.push(key + '=' + _value)
//       })
//     } else {
//       //_result.push(value)
//       _result.push(key + '=' + value)
//     }
//   }
//   if (isSort) _result.sort()
//   return _result
//     .map((item) => {
//       return item.split('=')[1]
//     })
//     .join('')
// }

export function convertObj(data = {}, isSort = false) {
  var _result = []

  for (var key in data) {
    var value = data[key]
    if (value === null || typeof value === 'undefined') continue
    if (Array.isArray(value)) {
      console.log('数组的参数', { value })
      value.forEach(function (_value, index) {
        //_result.push(_value)
        if (Object.prototype.toString.call(_value) == '[object Object]') {
          console.log(111, _value, '处理后', key + '=' + convertObj(_value, true))
          _result.push(key + '=' + convertObj(_value, true))
        } else if (Array.isArray(_value)) {
          _result.push(key + '=' + convertObj({ key: _value }, true))
        } else {
          _result.push(key + '[' + index + ']' + '=' + _value)
        }
      })
    } else if (Object.prototype.toString.call(value) == '[object Object]') {
      _result.push(key + '=' + convertObj(value, true))
    } else {
      //_result.push(value)
      _result.push(key + '=' + value)
    }
  }

  if (isSort) {
    let maps = {}
    console.log(_result, 'result')
    _result.forEach((item) => {
      let [key, val] = item.split('=')
      if (maps[key]) {
        maps[key].push(val)
      } else {
        maps[key] = [val]
      }
    })
    let mapKeySort = Object.keys(maps).sort((a, b) => {
      const arrayMatchA = a.match(/(.+?)\[(\d+)\]/) // 检查是否有数组索引
      const arrayMatchB = b.match(/(.+?)\[(\d+)\]/)

      if (arrayMatchA && arrayMatchB && arrayMatchA[1] == arrayMatchB[1]) {
        // 如果两个字符串都有数组索引，按名称排序后按索引排序
        const nameCompare = arrayMatchA[1].localeCompare(arrayMatchB[1])
        return nameCompare !== 0 ? nameCompare : parseInt(arrayMatchA[2], 10) - parseInt(arrayMatchB[2], 10)
      } else {
        // 没有数组索引时，按倒序排列
        return b.localeCompare(a)
      }
    })
    return Crypto.base64Encode(mapKeySort.map((key) => maps[key].join('')).join(''))
  }

  return Crypto.base64Encode(
    _result
      .map((item) => {
        return item.substring(item.indexOf('=') + 1)
      })
      .join('')
  )
}

/**
 * @description 计算百分比
 * @param 分子
 * @param 分母
 * @returns 返回数字形式百分比
 */
export function percentage(num, total) {
  if (num == 0 || total == 0) {
    return 0
  }
  return Math.round((num / total) * 10000) / 100.0 > 100 ? 100.0 : Math.round((num / total) * 10000) / 100.0 // 小数点后两位百分比
}

/**
 * @description 将秒数转换为时分秒
 * @param 秒数
 */
export const formatSeconds = (value) => {
  let secondTime = parseInt(value.toString()) // 秒
  let minuteTime = 0 // 分
  let hourTime = 0 // 小时
  if (secondTime >= 60) {
    minuteTime = parseInt((secondTime / 60).toString())
    secondTime = parseInt((secondTime % 60).toString())
    if (minuteTime >= 60) {
      hourTime = parseInt((minuteTime / 60).toString())
      minuteTime = parseInt((minuteTime % 60).toString())
    }
  }
  let result = '' + (parseInt(secondTime.toString()) < 10 ? '0' + parseInt(secondTime.toString()) : parseInt(secondTime.toString()))

  // if (minuteTime > 0) {
  result = '' + (parseInt(minuteTime.toString()) < 10 ? '0' + parseInt(minuteTime.toString()) : parseInt(minuteTime.toString())) + ':' + result
  // }
  // if (hourTime > 0) {
  result = '' + (parseInt(hourTime.toString()) < 10 ? '0' + parseInt(hourTime.toString()) : parseInt(hourTime.toString())) + ':' + result
  // }
  return result
}

/**
 * @description 轮询请求 用于页面报错兼容（当所有请求都失败时再返回error）
 * @param 请求fn及参数  格式为{fn:app.$api.xx,params:请求参数}
 * */
export const pollingQuery = (list = []) => {
  let err = 0
  let num = 0
  let resArr = new Array(list.length)
  const queryInfo = async (list, resolve, reject) => {
    await list[num]?.['fn'](list[num]['params'])
      .then((res) => {
        resArr[num] = {
          status: 'fulfilled',
          value: res
        }
        num++
        if (num === list.length) {
          err === list.length ? reject('all request error') : resolve(resArr)
        }
      })
      .catch((e) => {
        resArr[num] = {
          status: 'rejected',
          reason: e
        }
        err++
        num++
        if (num === list.length) {
          err === list.length ? reject('all request error') : resolve(resArr)
        }
      })
      .finally(() => {
        if (num < list.length) {
          queryInfo(list, resolve, reject)
        }
      })
  }

  return new Promise((resolve, reject) => {
    queryInfo(list, resolve, reject)
  })
}

const customFormat = ({ value, currency }) => {
  if (currency.code === 'IDR') {
    return `${currency.code} ${Number(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
  }
  console.log(`${currency.code} ${trimDecimal(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`)

  return `${currency.code} ${trimDecimal(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}

function trimDecimal(value) {
  // 转成字符串
  const str = String(value)

  // 判断是否有小数
  if (str.includes('.')) {
    const [intPart, decPart] = str.split('.')

    // 如果小数是两位并且为00，则去掉小数
    if (decPart.length === 2 && decPart === '00') {
      return intPart
    }
  }

  return str
}

export const formatPrice = (cents, currency = 'USD') => {
  if (!cents) return ''
  cents = String(cents)
  const len = cents.length
  if (len <= 2) return '0.' + cents.padStart(2, '0')
  return `${customFormat({
    value: cents.slice(0, len - 2) + '.' + cents.slice(len - 2),
    currency: {
      code: currency
    }
  })}`
}
